/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

export const RedirectRoutePage: React.FC = (): JSX.Element => {
  const location = useLocation();
  console.log('location in redirect route page', location);

  return (
    <Redirect
      to={{
        pathname: '/',
        search: location.search,
      }}
    />
  );
};

export default RedirectRoutePage;
